import { useTranslation } from 'react-i18next'

import { RadioGroupOption } from 'components/Form'
import {
  BulkManagementScope,
  bulkManagementScope,
} from 'features/inventory/domain/types/bulkManagementScope'
import { useAuthUser } from 'features/user'

export const useScopeOptions = (): RadioGroupOption[] => {
  const { t } = useTranslation('features/domain')
  const {
    helpers: { getProductStatus },
  } = useAuthUser()

  const inactivePrebidStack: boolean = getProductStatus('prebidStack') === 'inactive'

  return bulkManagementScope.map((scope: BulkManagementScope): RadioGroupOption => {
    const prebidStackRequiredProps: Partial<RadioGroupOption> =
      scope === 'full' && inactivePrebidStack
        ? {
            disabled: true,
            tooltip: {
              content: t(`form.general.bulkManagement.parameterScope.prebidStackRequired`),
            },
          }
        : {}

    return {
      label: t(`form.general.bulkManagement.parameterScope.values.${scope}`),
      value: scope,
      ...prebidStackRequiredProps,
    }
  })
}
